const localMediaFiles = new Map<string, File>();

function register(files: FileList): void {
  Array.from(files).forEach((file) => {
    localMediaFiles.set(file.name, file);
  });
}

function get(fileName: string): File | undefined {
  return localMediaFiles.get(fileName);
}

export default {
  register,
  get,
};
